import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

import iogDebugTextJSON from "./debug_iog.json";
const iogDebugText = iogDebugTextJSON.text;

class Debug extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>RPGONE Translations - Debug Modes (SNES)</title>
          <meta
            name="title"
            content="Snes game Debug Mode PAR codes for Neugier: The Journey Home, Illusion of Gaia, Aim for the Ace! Ace wo Nerae!, Magical Land of Wozz, Magical Quest 3 starring Mickey & Donald, DoReMi Fantasy : Milon's Quest"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary" id="neugier">
            <div className="panel-heading">
              <b className="subtitle">
                <div>Neugier - The Journey Home</div>
              </b>
              <span className="subtitle">
                <div>Debug Mode</div>
              </span>
            </div>
            <div className="panel-body">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <i>Enter cheat codes at the title screen</i>
                  <br />
                  <b className="text-muted">Debug Mode</b> - Up, Up, Down,
                  Top-Right, Top-Left<br />
                  <b className="text-muted">Max HP + Max Levels</b> - Left,
                  Right, Down, Up, X, Y<br />
                  <b className="text-muted">
                    Max HP + Max Levels + All Items
                  </b>{" "}
                  - Right, Left, Up, Down, X, Y<br />
                  <br />
                  Or can instead use a PAR code to access the Debug Mode. Enter
                  code at the title screen<br />
                  <b className="text-muted">Debug Mode</b> - 7E018AFF<br />
                  <b className="text-muted">
                    Sound Effect fix for Debug Mode
                  </b>{" "}
                  - 1ACF9303
                </div>
              </div>
              <div className="center-image">
                <b>
                  Left is English Translated debug mode, then the original
                  Japanese version
                </b>
                <br />
                <img
                  src={require("./img/debug/neugier_debug.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/neugier_japanese.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              Sound Effect option doesn't work, but can be re-enabled with this
              PAR code - 1ACF9303<br />
              The Stage Select works ok, but the Boss Fight option doesn't work.<br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary" id="illusion">
            <div className="panel-heading">
              <b className="subtitle">
                <div>Illusion of Gaia</div>
              </b>
              <span className="subtitle">
                <div>Debug Mode - Stage Select</div>
              </span>
            </div>
            <div className="panel-body">
              The Debug Man is spawned in a map and when a player talks to it,
              gives max HP, 127 STR+DEF, and all special abilities, then offers
              a stage select dialogue tree to teleport the player to any
              location in the game.<br />
              <br />To enable the debug man in the US rom, at $0c82fd write
              $20,$ee,$8b to have the Debug Man outside the school, in place of
              the unimportant NPC who usually spawns there.<br />
              <br />
              <b>Thanks to Raeven0 for help with enabling the Debug Man.</b>
              <br />
              <br />
              <a href="http://gaiathecreator.blogspot.com/">
                Gaia The Creator
              </a>{" "}
              - Illusion of Gaia game editor<br />
              <br />
              <div className="center-image">
                <img
                  src={require("./img/debug/Illusion_of_Gaia_Debug_001.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/Illusion_of_Gaia_Debug_002.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/Illusion_of_Gaia_Debug_003.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              <div className="panel panel-default">
                <div className="panel-heading">
                  <i>Debug Man text</i>
                  <br />
                  <i>Illusion of Time - Start: 5F260h, End: 5F3C6h</i>
                  <br />
                  <i>Illusion of Gaia - Start: BF211h, End: BF377h</i>
                  <br />
                  <br />

                  <div dangerouslySetInnerHTML={{ __html: iogDebugText }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary" id="ace">
            <div className="panel-heading">
              <b className="subtitle">
                <div>Aim for the Ace! (Ace wo Nerae!)</div>
              </b>
              <span className="subtitle">
                <div>Debug Codes</div>
              </span>
            </div>
            <div className="panel-body">
              <div className="panel panel-default">
                <div className="panel-heading">
                  80C52F00 - Press "Select & Top-Right" in-game to end the
                  current Match and WIN<br />
                  <br />
                  80C53F00 - Press "Select & Top-Left" in-game to end the
                  current Match and LOSE
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary" id="wozz">
            <div className="panel-heading">
              <b className="subtitle">
                <div>The Magical Land of Wozz</div>
              </b>
              <span className="subtitle">
                <div>Sound Test</div>
              </span>
            </div>
            <div className="panel-body">
              In the Wozz Manual, it shows off 2 sound debug functions that were
              not left in the final version, seen at the bottom of the far-right
              menu.<br />
              <br />
              <div className="center-image">
                <b>
                  Below from left, English translation of options menu, Japanese
                  options menu, options menu with sound test options (screenshot
                  from manual)
                </b>
                <br />
                <img
                  src={require("./img/debug/wozz1.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/Wozz(JAP)_00002.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/wozz_debug_manual.jpg")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              <b>Extra debug text translates as:</b>
              <br />
              Sound Test (0: Wozz Intro)<br />
              Sound Effect Test
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary" id="mickey3">
            <div className="panel-heading">
              <b className="subtitle">
                <div>Magical Quest 3 starring Mickey & Donald</div>
              </b>
              <span className="subtitle">
                <div>Debug Mode</div>
              </span>
            </div>
            <div className="panel-body">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <b className="text-muted">Set the debug RAM flag</b>
                  <br />
                  7E00FE 01 - Stage/Area select screen<br />
                  <span className="parCode-padding" />02 - XY character position
                  coordinates<br />
                  <span className="parCode-padding" />06 - Co-ordinates, no
                  music only sound effects<br />
                  <span className="parCode-padding" />08 - Debug start menu but
                  no other debug options<br />
                  <span className="parCode-padding" />10 - Show CPU usage
                  (Lines), start and select resets game<br />
                  <span className="parCode-padding" />20 - In-game debug menu
                  (need SRAM enabled)<br />
                  <span className="parCode-padding" />40 - Show CPU usage
                  (Coins)<br />
                  <span className="parCode-padding" />80 - All Costumes<br />
                  <span className="parCode-padding" />FF - All debug enabled<br />
                  <br />
                  <i>
                    Alternatively you can enable debug by setting a byte in the
                    ROM
                  </i>
                  <br />
                  80FE00 XX -{" "}
                  <b className="text-muted">Set the debug flag above</b>,
                  currently 00 so debug does not appear<br />
                  <br />
                  80FFD8 02 - <b className="text-muted">Enable SRAM</b> to
                  access the ingame debug menu(20)<br />
                  <span className="parCode-padding-full italic">
                    (Set FFD8h to 02 with hex editor in ROM without header)
                  </span>
                </div>
              </div>
              <div className="center-image">
                <i>
                  This game has a huge debug mode, most notable including a
                  level object editor, sprite animation viewer and a playable
                  test stage
                </i>
                <br />
                <img
                  src={require("./img/debug/mickey3e_00005.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3debugafter.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00001.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00002.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00003.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00032.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              <div className="center-image">
                <i>
                  There is a playable test stage with the 'round star bricks'
                  from Mickey & Minnie : Great Circus Mystery.
                </i>
                <br />
                <img
                  src={require("./img/debug/mickey3e_00023.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00027.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/mickey3e_00031.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary" id="doremi">
            <div className="panel-heading">
              <b className="subtitle">
                <div>DoReMi Fantasy : Milon's Quest</div>
              </b>
              <span className="subtitle">
                <div>Debug Mode</div>
              </span>
            </div>
            <div className="panel-body">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <i>Enter code at title screen and press Start</i>
                  <br />
                  7E0030 0E - <b className="text-muted">Visual Scene Viewer</b>
                  <br />
                  7E0030 0F - <b className="text-muted">Level Objects Editor</b>
                  <br />
                  7E0030 10 - <b className="text-muted">Level Layout Viewer</b>
                  <br />
                  <br />
                  Visual Scene Debug<br />
                  05 - End of world 1<br />
                  11 - End of world 2<br />
                  17 - End of world 3<br />
                  23 - End of world 4<br />
                  31 - End of world 5<br />
                  37 - End of world 6<br />
                </div>
              </div>
              <div className="center-image">
                <b>Visual Scene Viewer</b>
                <br />
                Displays each dialogue scene in the game.
                <br />
                <img
                  src={require("./img/debug/doremi_00001.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              <div className="center-image">
                <b>Level Objects Editor</b>
                <br />
                This editor allows setting all the objects in a level, such as
                enemies and items.
                <br />
                SRAM needs to be enabled to use this editor, so the Pro Action
                Replay code C0FFD804 is also required.
                <br />
                Press Start to save your changes to SRAM, and then hold Start &
                Select to play the level with your changes made.
                <br />
                <img
                  src={require("./img/debug/doremi1.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/doremi2.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/doremi3.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
              <br />
              <div className="center-image">
                <b>Level Layout Viewer</b>
                <br />
                After selecting a level, the viewer shows the collision
                detection hex code for each layout tile in the level.
                <br />
                Press X to toggle the hex codes, press Y to toggle the level
                tiles, or press A & Select to return to the initial level select
                screen.
                <br />
                <img
                  src={require("./img/debug/doremiDebug_00000.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/doremiDebug_00001.png")}
                  alt=""
                  className="imageResize"
                />{" "}
                <img
                  src={require("./img/debug/doremiDebug_00002.png")}
                  alt=""
                  className="imageResize"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Debug);



// WEBPACK FOOTER //
// ./src/Debug.js